import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import WorkflowListPage from './workflow-list-page';

export default function WorkflowPage() {
  const location = useLocation();
  const hideList = /\/workflow\/\d+\/(diseno|config|workflow-empresa\/\d+\/diseno)$/.test(location.pathname);

  return (
    <>
      {!hideList && <WorkflowListPage />}
      <Outlet />
    </>
  );
}
